import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { AppContextProvider } from '../../../AppLoader';
import { EnforcementCard } from '../EnforcementCard';
import { ButtonWithLoader } from '../../../ButtonWithLoader/ButtonWithLoader';
import { ThemedText } from '../../../ThemedComponents';

/**
 * redesigned email "confirm email" first step (wix-2025). Thin wrapper on
 * `EnforcementCard` (informational — no input): shows the account email and a
 * "Send Code" button that emails the code and advances to the code step.
 */
export const ConfirmEmailRedesign: React.FC = observer(() => {
  const { t } = useTranslation();
  const {
    rootStore: {
      postLoginStore: { premiumUsers2FaEnforcementStore: store },
      displayStore: { preset },
    },
  } = useContext(AppContextProvider);
  const confirmEmail = store.confirmEmail;

  return (
    <EnforcementCard
      priority="secondary"
      title={confirmEmail.titleFirstStep}
      subtitle={confirmEmail.subtitleFirstStep}
      showBackButton
      backButtonCallback={store.goBackToEnforcementOrChooseBackupMethod}
      primaryButton={
        // onFirstStepConfirm is action.bound → safe as a bare reference.
        <ButtonWithLoader
          skin={preset.buttonDesign?.skin ?? 'standard'}
          onClick={confirmEmail.onFirstStepConfirm}
          disabled={confirmEmail.isSubmitted}
        >
          {confirmEmail.firstStepButtonConfirmText}
        </ButtonWithLoader>
      }
    >
      <Box direction="vertical" width="100%" gap={2}>
        <ThemedText>
          {t('confirmEmailBeforeTwoFactorEmailModal.content')}
        </ThemedText>
        <ThemedText weight="bold" dir="ltr">
          {confirmEmail.email}
        </ThemedText>
      </Box>
    </EnforcementCard>
  );
});
